export const FORM_CONSTANTS = {
  SAVE_AS_DRAFT: 'Save as Draft',
}

export enum RECORD_STATUS {
  DRAFT = 'DRAFT',
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}

export const ROWS_TAB_DIFFERENCE = 100
export const ROWS_TAB_DIFFERENCE_FOR_SUBFORM = 500
export const ROWS_TAB_DIFFERENCE_FOR_WORK_FOW = 10000
export const ROWS_TAB_DIFFERENCE_FOR_LAYOUT_RENDER_TABS = 2000
export const TAB_INDEX = 1
export const TAB_INDEX_DEFAULT = 0

export enum ShortcutKeys {
  Enter = 'Enter',
  Space = ' ',
  Tab = 'Tab',
  Alt = 'Alt',
  ArrowUp = 'ArrowUp',
  ArrowDown = 'ArrowDown',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
  Escape = 'Escape',
  Shift = 'Shift',
}
